import React from 'react'

function getDryIce(fleetType, ship_no) {
  let fwd = ''
  let a_fwd = ''
  fleetType = parseInt(fleetType)
  ship_no = parseInt(ship_no || 0)

  if (fleetType === 332 || fleetType === 333 || fleetType === 339) {
    fwd = '1300 LBS (590 KG)'
  } else if (fleetType === 359) {
    fwd = '575 LBS (261 KG)'
  } else if (ship_no >= 1607 && ship_no <= 1613) {
    fwd = 'FORBIDDEN'
  } else if (fleetType === 763) {
    fwd = '100 LBS (45 KG)'
  } else if (fleetType === 764) {
    fwd = '1250 LBS (567 KG)'
  } else {
    fwd = ''
  }

  if (fleetType === 332 || fleetType === 333 || fleetType === 339) {
    a_fwd = '2204 LBS (1000 KG)'
  } else if (fleetType === 359) {
    a_fwd = '1920 LBS (871 KG)'
  } else if (ship_no >= 1607 && ship_no <= 1613) {
    a_fwd = 'FORBIDDEN'
  } else if (fleetType === 763) {
    a_fwd = '100 LBS (45 KG)'
  } else if (fleetType === 764) {
    a_fwd = '2000 LBS (907 KG)'
  } else {
    a_fwd = ''
  }

  let aft = ''
  let a_aft = ''
  if (fleetType === 332 || fleetType === 333 || fleetType === 339) {
    aft = 'FORBIDDEN'
  } else if (fleetType === 359) {
    aft = '480 LBS (218 KG)'
  }
  else if (fleetType === 763 || fleetType === 764) {
    aft = 'FORBIDDEN'
  } else {
    aft = ''
  }

  if (fleetType === 332 || fleetType === 333 || fleetType === 339) {
    a_aft = 'FORBIDDEN'
  } else if (fleetType === 359) {
    a_aft = '1600 LBS (726 KG)'
  } else if (fleetType === 763 || fleetType === 764) {
    a_aft = 'FORBIDDEN'
  } else {
    aft = ''
  }

  let bulk = ''
  let a_bulk = 'N/A'

  if (fleetType === 332 || fleetType === 333 || fleetType === 339) {
    bulk = 'FORBIDDEN'
  }
  else if (fleetType === 359) {
    bulk = '180 LBS (82 KG)'
  } else if (fleetType === 763 || fleetType === 764) {
    bulk = 'FORBIDDEN'
  } else {
    bulk = ''
  }

  return {
    fwd,
    aft,
    bulk,
    a_aft,
    a_fwd,
    a_bulk
  }
}

const DryIce = (props) => {
  const data = getDryIce(props.fleetType, props.ship_no)

  return (
    <div className='mb-2'>
      <p className='mt-2 mb-1 dry-ice-main-title text-center'><b>DRY ICE LIMITS</b></p>
      <div className='dry-ice-content'>
        <table className='dry-ice-table'>
          <thead>
            <tr>
              <th></th>
              <th>Standard</th>
              <th>Active Con.</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><b>FWD:</b></td>
              <td>{data.fwd}</td>
              <td>{data.a_fwd}</td>
            </tr>
            <tr>
              <td><b>AFT:</b></td>
              <td>{data.aft}</td>
              <td>{data.a_aft}</td>
            </tr>
            <tr>
              <td><b>BULK:</b></td>
              <td>{data.bulk}</td>
              <td>{data.a_bulk}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
export default DryIce